import React from 'react';
import {Redirect, Route} from 'react-router';
import routes from './analytics/routes';
import components from './analytics/components';

const createRoutedComponent = (route, index) => {
  // eslint-disable-next-line
  return props => {
    return React.createElement(
      components[index],
      {
        analyticsPage: route.name,
        ...props
      }
    );
  };
};

/*
 * Renders routes for each page of the analytics section,
 * as defined by the 'routes' array in the analytics module.
 */
const renderAnalyticsRoutes = (baseAnalyticsPath) => {
  const indexRedirect = (
    <Redirect
      key='index'
      from={baseAnalyticsPath}
      to={`${baseAnalyticsPath}/${routes[0].name}`} />
  );
  return [indexRedirect].concat(
    routes.map((route, index) => {
      const RoutedComponent = createRoutedComponent(route, index);
      return (
        <Route
          key={route.name}
          path={`${baseAnalyticsPath}/${route.name}`}
          component={RoutedComponent} />
      );
    })
  );
};

export default renderAnalyticsRoutes;



// WEBPACK FOOTER //
// ./src/routing/renderAnalyticsRoutes.js